package com.milta.core.localization.translations.pl

import com.milta.core.localization.WebDashboardStrings

internal val WebDashboard = WebDashboardStrings(
    refreshButtonLabel = "Odśwież",
    expandedStopsTitle = "Przystanki",
    stopStatusWaitingLabel = "Oczekuje",
    stopStatusFailedLabel = "Niedostarczone",
)
